import {
  ProgressChecklist,
  ProgressChecklistItem,
} from '@app/components/ProgressChecklist'
import { ListingType } from '@app/models/enums'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { PipelinePageProps } from './PipelinePage'

export default class PipelineProgress extends React.PureComponent<
  PipelinePageProps
> {
  public render() {
    const progress = this.props.pipeline.progress
    const isLease = this.props.pipeline.listing.type === ListingType.Lease

    return (
      <DocumentTitle title={`${this.props.pipeline.name} :: Progress`}>
        <ProgressChecklist>
          <ProgressChecklistItem
            label='General Information'
            isComplete={this._isGeneralInformationComplete()}
          >
            <ProgressChecklistItem
              label='Effective Date'
              isComplete={progress.hasEffectiveDate}
            />
            <ProgressChecklistItem
              label={isLease ? 'Execution Date' : 'Closing Date'}
              isComplete={progress.hasClosingDate}
            />
            <ProgressChecklistItem
              label={isLease ? 'Total Lease Value' : 'Sales Price'}
              isComplete={progress.hasSalesPrice}
            />
            <ProgressChecklistItem
              label={'Earnest Money'}
              isComplete={progress.hasEarnestMoney}
              isVisible={!isLease}
            />
            <ProgressChecklistItem
              label={'Earnest Money Location'}
              isComplete={progress.hasEarnestMoneyLocation}
              isVisible={!isLease}
            />
          </ProgressChecklistItem>
          <ProgressChecklistItem
            label={isLease ? 'Tenant Information' : 'Buyer Information'}
            isComplete={this._isBuyerInformationComplete()}
          >
            <ProgressChecklistItem
              label={isLease ? 'Tenant(s)' : 'Buyer(s)'}
              isComplete={progress.hasBuyers}
            />
            <ProgressChecklistItem
              label={isLease ? "Tenant's Agent(s)" : 'Selling Agent(s)'}
              isComplete={progress.hasSellingAgents}
            />
            <ProgressChecklistItem
              label={"Buyer's Lender"}
              isComplete={progress.hasBuyerLender}
              isVisible={!isLease}
            />
            <ProgressChecklistItem
              label='Title Company'
              isComplete={progress.hasBuyersTitleCompany}
              isVisible={!isLease}
            />
          </ProgressChecklistItem>
          <ProgressChecklistItem
            label={isLease ? 'Landlord Information' : 'Seller Information'}
            isComplete={this._isSellerInformationComplete()}
          >
            <ProgressChecklistItem
              label={isLease ? 'Landlord(s)' : 'Seller(s)'}
              isComplete={progress.hasSellers}
            />
            <ProgressChecklistItem
              label={isLease ? "Landlord's Agent(s)" : 'Listing Agent(s)'}
              isComplete={progress.hasListingAgents}
            />
            <ProgressChecklistItem
              label={"Seller's Mortgage"}
              isComplete={progress.hasSellerMortage}
              isVisible={!isLease}
            />
            <ProgressChecklistItem
              label='Title Company'
              isComplete={progress.hasSellersTitleCompany}
              isVisible={!isLease}
            />
          </ProgressChecklistItem>
          <ProgressChecklistItem
            label='Critical Dates'
            isComplete={
              progress.completedCriticalDates === progress.totalCriticalDates
            }
          >
            {this.props.pipeline.criticalDates.toArray().map((c) => (
              <ProgressChecklistItem
                key={c.id}
                label={c.title}
                isComplete={c.isComplete}
              />
            ))}
          </ProgressChecklistItem>
        </ProgressChecklist>
      </DocumentTitle>
    )
  }

  private _isGeneralInformationComplete() {
    return (
      this.props.pipeline.progress.hasEffectiveDate &&
      this.props.pipeline.progress.hasClosingDate &&
      this.props.pipeline.progress.hasSalesPrice &&
      (this.props.pipeline.listing.type === ListingType.Lease ||
        (this.props.pipeline.progress.hasEarnestMoney &&
          this.props.pipeline.progress.hasEarnestMoneyLocation))
    )
  }

  private _isBuyerInformationComplete() {
    return (
      this.props.pipeline.progress.hasBuyers &&
      this.props.pipeline.progress.hasSellingAgents &&
      (this.props.pipeline.listing.type === ListingType.Lease ||
        (this.props.pipeline.progress.hasBuyerLender &&
          this.props.pipeline.progress.hasBuyersTitleCompany))
    )
  }

  private _isSellerInformationComplete() {
    return (
      this.props.pipeline.progress.hasSellers &&
      this.props.pipeline.progress.hasListingAgents &&
      (this.props.pipeline.listing.type === ListingType.Lease ||
        (this.props.pipeline.progress.hasSellerMortage &&
          this.props.pipeline.progress.hasSellersTitleCompany))
    )
  }
}
